<template>
    <v-container fluid>
        <v-layout>
            <v-flex><h1 class="display-2">Gestión de roles</h1></v-flex>
        </v-layout>
        <v-layout column>
            <v-card>
                <v-card-title>
                    <v-spacer></v-spacer>
                    <v-btn icon flat color="green" @click.stop="add()">
                        <v-icon>add</v-icon>
                    </v-btn>
                </v-card-title>
                <v-data-table :headers="headers" :items="items"
                              :pagination.sync="pag"
                              :loading="loading"
                              :rows-per-page-items="rows"
                              rows-per-page-text="Filas por pagina"
                              :total-items="totalItems"
                >
                    <template slot="items" slot-scope="props">
                        <td class="text-xs-right">{{ props.item.name }}</td>
                        <td class="text-xs-right">{{ props.item.display_name }}</td>
                        <td class="text-xs-right">{{ props.item.description }}</td>
                        <td class="text-xs-center">
                            <v-btn icon flat color="blue" @click.stop="edit(props.item)">
                                <v-icon>edit</v-icon>
                            </v-btn>
                            <v-btn icon flat color="red" @click="destroy(props.item)" :loading="loadingDel === props.item.id">
                                <v-icon>delete</v-icon>
                            </v-btn>
                        </td>
                    </template>
                </v-data-table>
            </v-card>
        </v-layout>
        <v-dialog v-model="dialog" scrollable persistent max-width="500">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>{{ operTxt }}</v-card-title>
                <v-card-text>
                    <v-form>
                        <v-text-field
                                v-model="form.name"
                                v-validate="'required|max:20'"
                                :counter="20"
                                label="Nombre"
                                :error-messages="errores.collect('name')"
                                data-vv-name="name"
                                required
                        ></v-text-field>
                        <v-text-field
                                v-model="form.display_name"
                                v-validate="'required|max:100'"
                                :counter="100"
                                label="Nombre a mostrar"
                                :error-messages="errores.collect('display_name')"
                                data-vv-name="display_name"
                                required
                        ></v-text-field>
                        <v-text-field v-model="form.description" label="Descripción" required></v-text-field>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn v-if="oper === 'add'" color="primary" flat @click="store()" :loading="loadingCrud">Agregar</v-btn>
                    <v-btn v-else color="primary" flat @click="update()" :loading="loadingCrud">Guardar</v-btn>
                    <v-btn color="error" flat @click="clear()">Cancelar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <errores v-model="msj.mostrar" :datos="msj"></errores>
    </v-container>
</template>

<script>
    import errores from '../../components/Errores';
    import mixinRole from '../../mixins/auth/roles';

    export default {
        name: "roles",
        $_veeValidate: {validator: 'new'},
        components: {errores},
        mixins: [mixinRole],
        data() {
            return {
                loading: false,
                loadingCrud: false,
                loadingDel: -1,
                dialog: false,
                oper: 'add',
                headers: [
                    {text: 'Nombre de rol', value: 'name', align: 'center'},
                    {text: 'Nombre a mostrar', value: 'display_name', align: 'center'},
                    {text: 'Descripción', value: 'description', align: 'center'},
                    {text: 'Operaciones', value: '', align: 'center'},

                ],
                items: [],
                pag: {},
                rows: [10, 20, 30, {text: 'All', value: -1}],
                totalItems: 0,
                msj: {mostrar: false, txt: '', tipo: ''},
                form: {
                    id: '',
                    name: '',
                    display_name: '',
                    description: ''
                }
            }
        },
        computed: {
            operTxt() {
                return (this.oper === 'add') ? 'Agregar registro' : 'Editar registro';
            }
        },
        watch: {
            pag: {
                handler() {
                    this.getTable();
                },
                deep: true
            }
        },
        mounted() {
            this.getTable();
        },
        methods: {
            getTable() {
                this.loading = true;
                this.rolesIndex(this.pag, r => {
                    this.items = r.data;
                    this.totalItems = r.total;
                    this.loading = false;
                }, err => {
                    this.loading = false;
                    console.log(err);
                })
            },
            add() {
                this.oper = 'add';
                this.dialog = true;
            },
            edit(d) {
                this.oper = 'edit';
                this.form = d;
                this.dialog = true;
            },
            destroy(d) {
                this.loadingDel = d.id;
                this.rolesDestroy(d.id, r => {
                    this.msj = r;
                    this.loadingDel = -1;
                    this.getTable();
                }, err => {
                    this.msj = {mostrar: true, tipo: 'error', txt: 'Error al eliminar registro'};
                    this.loadingDel = -1;
                })
            },
            store() {
                this.$validator.validateAll()
                    .then(r => {
                        if (!r) {
                            this.msj = {mostrar: true, tipo: 'error', txt: 'Error de validación'};
                            return false;
                        }
                        this.loadingCrud = true;
                        this.rolesStore(this.form, r => {
                            this.msj = r;
                            this.loadingCrud = false;
                            this.clear();
                            this.getTable();
                        }, err => {
                            console.log('error al agregar', err);
                            this.msj = {mostrar: true, tipo: 'error', txt: 'Error de guardado'};
                            this.loadingCrud = false;
                        })
                    })
                    .catch(err => {
                        this.msj = {mostrar: true, tipo: 'error', txt: 'Error de validación'};
                    })
            },
            update() {
                this.$validator.validateAll()
                    .then(r => {
                        if (!r) {
                            this.msj = {mostrar: true, tipo: 'error', txt: 'Error de validación'};
                            return false;
                        }
                        this.loadingCrud = true;
                        this.rolesUpdate(this.form, r => {
                            this.msj = r;
                            this.loadingCrud = false;
                            this.clear();
                            this.getTable();
                        }, err => {
                            console.log('error al agregar', err);
                            this.msj = {mostrar: true, tipo: 'error', txt: 'Error de guardado'};
                            this.loadingCrud = false;
                        })
                    })
                    .catch(err => {
                        this.msj = {mostrar: true, tipo: 'error', txt: 'Error de validación'};
                    })
            },
            clear() {
                this.name = '';
                this.display_name = '';
                this.description = '';
                this.$validator.reset();
                this.dialog = false;
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/pages/auth/roles.vue